export default __webpack_public_path__ + "e3e0cf50796a3bf0689e597ee53c2561.png";